import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Tabs, Tab } from "react-bootstrap";
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import AdminDashboard from "./admindashboard";
import LabProfile from "./labProfile";
import ViewAppointmentsByLabCorporate from "./viewAppointmentsByLabCorporate";
import ViewPemeAppointmentsForLab from "./viewPemeAppointmentsForLab";
import LabInvoices from "./labInvoicesTab";
import LabSettings from "./labSettings";
import LabAdminLink from "./labAdminLink";
import LabCoordinators from "./labCoordinators";

function LabProfileTab() {
  const data = JSON.parse(localStorage.getItem("data"));
  const userRole = data?.role;
  const localOrgCode = data?.orgcode;

  const { orgcode: paramOrgCode } = useParams();
  const orgcode = userRole === "ROLE_LAB" ? localOrgCode : paramOrgCode;

  const navigate = useNavigate();
  const defaultTab = userRole === "ROLE_LAB" ? "appointments" : "labProfile";
  const [activeTab, setActiveTab] = useState(defaultTab);
  const [labDetails, setLabDetails] = useState(null);
  const [loading, setLoading] = useState(false);

  const getData = async () => {
    if (!orgcode) return;

    setLoading(true);
    const token = data?.token;

    try {
      const response = await axios.get(`/api/labdetails/labcode=${orgcode}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setLabDetails(response.data);
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else {
        toast.error(error.response.data?.message || "An error occurred.");
      }
    } else {
      toast.error(error.message || "An error occurred.");
    }
  }

  useEffect(() => {
    getData();
  }, [orgcode]);

  return (
    <div>
      <AdminDashboard />

      <div className="col-12 mx-xl-auto ps-xl-10 mt-10">
        <div className="card card-raised">
          <div className="card-body">
            <Tabs
              id="lab-profile-tab"
              activeKey={activeTab}
              onSelect={(tab) => setActiveTab(tab)}
              className="mb-3"
            >
              {/* Conditionally Render Tabs */}
              {userRole !== "ROLE_LAB" && (
                <Tab eventKey="labProfile" title="Lab Profile">
                  {activeTab === "labProfile" && <LabProfile selectedOrgcode={orgcode} />}
                </Tab>
              )}

              {userRole !== "ROLE_LAB" && (
                <Tab eventKey="labCoordinators" title="Lab Co-ordinators">
                  {activeTab === "labCoordinators" && <LabCoordinators labcode={orgcode} />}
                </Tab>
              )}

              <Tab eventKey="appointments" title="Regular Appointments">
                {activeTab === "appointments" && <ViewAppointmentsByLabCorporate labcode={orgcode} />}
              </Tab>

              {labDetails?.id && (
                <Tab eventKey="pemeappointments" title="PEME Appointments">
                  {activeTab === "pemeappointments" && <ViewPemeAppointmentsForLab labId={labDetails.id} />}
                </Tab>
              )}

              {userRole !== "ROLE_LAB" && (
                <Tab eventKey="invoices" title="Invoices">
                  {activeTab === "invoices" && <LabInvoices labcode={orgcode} />}
                </Tab>
              )}

              {userRole !== "ROLE_LAB" && labDetails?.regulated === true && (
                <Tab eventKey="actions" title="Actions">
                  {activeTab === "actions" && <LabSettings labcode={orgcode} />}
                </Tab>
              )}

              {userRole === "ROLE_SUPER" && (
                <Tab eventKey="adminLink" title="Admin Link">
                  {activeTab === "adminLink" && <LabAdminLink selectedOrgcode={orgcode} />}
                </Tab>
              )}
            </Tabs>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LabProfileTab;
